import { authApiHandler } from '../services/authApi'
import type { AuthConfig, Contact } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

// Server side only: it needs the id token, which the browser cannot read.
export default (config: AuthConfig, cookieHeader?: string) => {
  const cookies = cookieHandler(cookieHeader)
  const token = tokenHandler(config)
  const authApi = authApiHandler(config)

  return async (): Promise<Contact[] | null> => {
    if (typeof window !== 'undefined') return null

    const idToken = cookies.getIdToken()

    if (!token.isValidToken(idToken)) return null

    const contacts = await authApi.getContacts(idToken, cookies.getContactId())

    return contacts.map(token.getContact).filter((contact): contact is Contact => contact !== null)
  }
}
